import React, { useEffect, useState, useMemo } from "react";
import { Checkbox, Radio, Input, Form, InputNumber, Alert } from "antd";
import { connect } from "react-redux";
import { ADDFIELDS } from "../../../core-units/constants/actionTypes";
import agent from "../../../agent";
import "../home-page.css";
import _ from "lodash";

const { TextArea } = Input;

const StepSellerDetails = (props) => {
  const [form] = Form.useForm();
  const [service, setService] = useState({});
  const [product, setProduct] = useState({});
  const [coupon, setCoupon] = useState({});
  const [total, setTotal] = useState(0);
  const [rego, setRego] = useState("Rego");
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [fieldStatus, setFieldStatus] = useState(false);
  const [client, setClientPhone] = useState("");
  const [allValues, setAllValues] = useState({
    name: "",
    phone: "",
    email: "",
    SellerName: "",
    SellerPhonenumber: "",
    CarLocation: "",
    CarModel: "",
    OdometerReading: "",
    CarIdNumber: "",
    price: "",
    notes: "",
    year: "",
  });

  /** Load initial data once */
  useEffect(() => {
    async function apiCall() {
      const storedService = localStorage.getItem("service");
      const storedProduct = localStorage.getItem("product");
      const storedValues = localStorage.getItem("allValues");
      const carAppNumber = localStorage.getItem("Rego");
      carAppNumber
        ? localStorage.setItem("Rego", carAppNumber)
        : localStorage.setItem("Rego", rego);
      const parsedService = storedService ? JSON.parse(storedService) : {};
      const parsedProduct = storedProduct ? JSON.parse(storedProduct) : {};
      const parsedValues = storedValues ? JSON.parse(storedValues) : {};
      setService(parsedService);
      setProduct(parsedProduct);
      setCoupon(localStorage.getItem("couponData"));
      setTotal(localStorage.getItem("total"));
      setAllValues(parsedValues);
      setRego(localStorage.getItem("Rego") || "Rego");
      setFieldStatus(JSON.parse(localStorage.getItem("feildStatus")) || false);
      setCheck1(JSON.parse(localStorage.getItem("check1")) || false);
      setCheck2(JSON.parse(localStorage.getItem("check2")) || false);

      // Load form values after data ready
      form.setFieldsValue(parsedValues);

      // Fetch additional fields from API
      props.fields({ "filter[service_id]": _.get(parsedService, "id") });
    }
    apiCall();
  }, []);

  /** Form value change handler */
  const onFormLayoutChange = (_, values) => {
    const merged = { ...allValues, ...values };
    setAllValues(merged);
    localStorage.setItem("allValues", JSON.stringify(merged));

    const emailPattern = /^([A-Za-z0-9._%+-])+@([A-Za-z0-9.-])+\.[A-Za-z]{2,}$/;
    const isValid =
      values.CarModel &&
      values.CarIdNumber &&
      values.SellerName &&
      values.email &&
      values.name &&
      Number.isFinite(values.OdometerReading) &&
      emailPattern.test(values.email);

    props.formvalidateHandler(isValid);
    setFieldStatus(isValid);
    localStorage.setItem("feildStatus", JSON.stringify(isValid));
  };

  /** Radio group change */
  const carNoChange = (e) => {
    const value = e.target.value;
    props.regoValidation(value);
    setRego(value);
    localStorage.setItem("Rego", value);
  };

  /** Terms checkboxes */
  const checkChange1 = (e) => {
    const value = e.target.checked;
    props.termsValidationHandler(value);
    setCheck1(value);
    localStorage.setItem("check1", JSON.stringify(value));
  };

  const checkChange2 = (e) => {
    const value = e.target.checked;
    props.checkValidationHandler(value);
    setCheck2(value);
    localStorage.setItem("check2", JSON.stringify(value));
  };

  /** Service & Price details */
  const serviceProductDetails = () => (
    <>
      <div className="PricingAddOnTitle">
        Your Details, Seller and Car Details
      </div>
      <div className="InspectionStepTitle">
        {_.get(service, "name")} <b>$ {_.get(service, "price")}</b>
        {_.map(product, (val, key) => (
          <React.Fragment key={key}>
            + {_.get(val, "name")} <b>$ {_.get(val, "price")}</b>
          </React.Fragment>
        ))}
      </div>
      <div className="CouponCodeTotal">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-2">
            <div className="CouponCodeTotalSection">
              <span>Total</span>
              <span className="CouponCodeTotalAmount">$ {total}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  /** Form info */
  const formInfo = () => (
    <Form
      form={form}
      layout="vertical"
      initialValues={allValues}
      onValuesChange={onFormLayoutChange}
      validateTrigger={["onBlur"]}
      className="row"
    >
      {/* Your Name */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Your Name"
        name="name"
        rules={[{ required: true, message: "Please input your username!" }]}
      >
        <Input />
      </Form.Item>

      {/* Email */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Your E-mail Address"
        name="email"
        rules={[
          {
            required: true,
            type: "email",
            message: "Please input your email!",
          },
        ]}
      >
        <Input />
      </Form.Item>

      {/* Phone */}
      <Form.Item
        className="col-12 col-lg-8 phone__number--preImg"
        label="Your Phone Number"
        name="phone"
        rules={[{ required: true, message: "Please input your phone!" }]}
      >
        <Input
          prefix={"+61"}
          onChange={(e) => setClientPhone("+61" + e.target.value)}
        />
      </Form.Item>

      <Form.Item className="col-12">
        <hr />
      </Form.Item>

      {/* Seller Info */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Seller Name"
        name="SellerName"
        rules={[{ required: true, message: "Please input your Seller Name!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        label="Seller Phone Number"
        name="SellerPhonenumber"
        rules={[
          { required: true, message: "Please input your Seller Phone Number!" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item className="col-12">
        <hr />
      </Form.Item>

      {/* Car Details */}
      <Form.Item
        className="col-12 col-lg-8"
        label="Car Make and Model"
        name="CarModel"
        rules={[{ required: true, message: "Please input your Car Model!" }]}
      >
        <Input placeholder="Hyundai i20" />
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        label="Car Manufactured Year"
        name="year"
      >
        <Input placeholder="2022" />
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        label="Car Odometer Reading"
        name="OdometerReading"
        rules={[
          { required: true, message: "Please enter Car Odometer Reading!" },
        ]}
      >
        <InputNumber placeholder="130,000" style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item className="col-12">
        <Radio.Group
          className="SellerDetailsRadioGroup"
          name="radiogroup"
          value={rego}
          onChange={carNoChange}
        >
          <Radio value="Rego">Car Rego Number</Radio>
          <Radio value="VIN">Car VIN Number</Radio>
          <Radio value="Chasis Number">Car Chasis Number</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        className="col-12 col-lg-8"
        name="CarIdNumber"
        rules={[
          { required: true, message: "Please input your Car appropriate Number!" },
        ]}
      >
        <Input placeholder="E.g. 123" />
      </Form.Item>

      {/* Notes */}
      <Form.Item className="col-12 col-lg-8" label="Notes" name="notes">
        <TextArea rows={3} />
      </Form.Item>

      {/* Terms Checkboxes */}
      <Form.Item className="col-12 col-lg-8">
        <div className="AcceptTermsCheckBoxSet">
          <Checkbox onChange={checkChange1} checked={check1} />
          <div className="AcceptTermsCheckBoxText">
            I agree to the&nbsp;
            <a
              className="footer-terms-conditions"
              href="https://www.safe-buy.com.au/read-the-terms-conditions-of-prepurchase-vehicle-services/"
              target="_blank"
            >
              Terms and Conditions
            </a>
          </div>
        </div>
        <div className="AcceptTermsCheckBoxSet">
          <Checkbox onChange={checkChange2} checked={check2} />
          <div className="AcceptTermsCheckBoxText">
            I agree to{" "}
            <a
              href="https://safebuy.com.au/booking-refund-and-cancellation-policy/"
              target="_blank"
            >
              Service, Booking and Refund Policy
            </a>
          </div>
        </div>
      </Form.Item>
    </Form>
  );

  /** Render */
  const visibleAlert = useMemo(() => props.isAlert, [props.isAlert]);

  return (
    <div className="StepSellerDetailsStepsContainer">
      <div className="StepAppointmentInfo">
        {serviceProductDetails()}
        {visibleAlert && (
          <div className="row justify-content-center">
            <div className="col-12 col-lg-7">
              <Alert
                message="Error"
                description="Please fill all required fields"
                type="error"
                showIcon
              />
            </div>
          </div>
        )}
        <div className="StepsFormCardContainer">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-7">
              <div className="StepsFormCard">{formInfo()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/** Redux */
const mapStateToProps = (state) => ({
  addfield: state.booking.additionalfields,
});

const mapDispatchToProps = (dispatch) => ({
  fields: (params, callback) =>
    dispatch({
      type: ADDFIELDS,
      payload: agent.Bookings.addition_feilds(params),
      callback,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepSellerDetails);
